
import { Component, Input } from '@angular/core';
import { NavigationNode } from '@spartacus/storefront';
import { NavLabelComponent } from '../../nav-label/nav-label.component';
import { NavArrowLeftComponent } from '../nav-arrow-left/nav-arrow-left.component';
import { NavArrowRightComponent } from '../nav-arrow-right/nav-arrow-right.component';

@Component({
  selector: 'sub-menu',
  standalone: true,
  imports: [NavLabelComponent, NavArrowLeftComponent, NavArrowRightComponent],
  templateUrl: './sub-menu.component.html',
  styleUrl: './sub-menu.component.scss',
})
export class SubMenuComponent {
  @Input() node!: NavigationNode;

  open(ev: any): void {
    const $btn = ev.currentTarget as HTMLElement;
    const $subMenu = $btn.closest('.js-menu-item')?.querySelector('.js-menu-list');

    $subMenu && $subMenu.classList.toggle('is-active');
  }

  removeUrl(node: NavigationNode) {
    return { ...node, url: '' };
  }

  close(ev: any): void {
    const $btn = ev.currentTarget as HTMLElement;
    const $subMenu = $btn.closest('.js-menu-list');

    $subMenu && $subMenu.classList.toggle('is-active');
  }
}
